import { Box, Typography } from "@mui/material";
import {
  formsWrapper,
  formsContainer,
  titleStyles,
  noFormsText,
} from "@features/formAssignments/FormsWrapperStyles";
import { FormsWrapperItem } from "./FormsWrapperItem";
import React from "react";
import { IFormAssignmentForm } from "../../../../types/formAssignments/IInOfficeEvent";

interface FormsWrapperProps {
  title: string;
  forms?: IFormAssignmentForm[];
  onDeleteForm?: (formId: number) => void;
}

export const FormsWrapper = ({
  title,
  forms,
  onDeleteForm,
}: FormsWrapperProps) => {
  const formsLength = forms?.length || 0;

  return (
    <Box sx={formsWrapper}>
      <Typography sx={titleStyles}>{title}</Typography>
      <Box sx={formsContainer}>
        {forms && forms.length > 0 ? (
          forms.map((form, index) => (
            <React.Fragment key={index}>
              <FormsWrapperItem form={form} onDeleteForm={onDeleteForm} />
              {formsLength > 1 && (
                <Box
                  sx={{
                    border:
                      "0.5px solid var(--graphical-elements-inactive-state-gray-ececec, #E5E5E5);",
                    alignSelf: "stretch",
                  }}
                ></Box>
              )}
            </React.Fragment>
          ))
        ) : (
          <Typography sx={noFormsText}>No forms</Typography>
        )}
      </Box>
    </Box>
  );
};
export default FormsWrapper;
